/**
 * As 15 rotas planas de /configuracao/* (Brief 4, o Gestor) deixaram de existir em
 * 30/Set/2026 (D5): 13 viraram ferramenta em /admin/<dominio>/<id>, 2 eram observação e
 * foram para Supervisão/Estratégia. Cada rota velha redireciona — bookmark, link em
 * mensagem e `<Link>` esquecido continuam chegando. O hash viaja (mesmo padrão dos
 * redirects de /admin/* da spec de 22/Ago §3.3).
 */
import { Navigate, Route, useLocation } from 'react-router-dom';

export const CONFIGURACAO_REDIRECTS: readonly { readonly from: string; readonly to: string }[] = [
  { from: 'playbooks', to: '/admin/ia/playbooks' },
  { from: 'personas', to: '/admin/ia/personas' },
  { from: 'quick-replies', to: '/admin/ia/quick-replies' },
  { from: 'matriz-transicao', to: '/admin/ia/matriz-transicao' },
  { from: 'risco-de-acao', to: '/admin/ia/risco-de-acao' },
  { from: 'classificacao', to: '/admin/ia/classificacao' },
  { from: 'gatilhos-tenant', to: '/admin/ia/gatilhos' },
  { from: 'bonds', to: '/admin/atendimento/bonds' },
  { from: 'times-roteamento', to: '/admin/atendimento/times-roteamento' },
  { from: 'importar-base', to: '/admin/organizacao/importar-base' },
  { from: 'agenda', to: '/admin/agenda/recursos' },
  { from: 'plantao', to: '/admin/agenda/plantao' },
  { from: 'templates-meta', to: '/admin/integracoes/templates-meta' },
  { from: 'qualidade-ia', to: '/supervisor/qualidade-ia' },
  { from: 'insights', to: '/estrategia/insights-gestor' },
];

function RedirectComHash({ to }: { readonly to: string }): JSX.Element {
  const { hash } = useLocation();
  return <Navigate to={`${to}${hash}`} replace />;
}

export function configuracaoRedirects(): JSX.Element {
  return (
    <>
      {CONFIGURACAO_REDIRECTS.map((r) => (
        <Route
          key={r.from}
          path={`configuracao/${r.from}`}
          element={<RedirectComHash to={r.to} />}
        />
      ))}
    </>
  );
}
